<template>
  <div class="container">
    <section class="row">
        <div class="col-xs-12 col-xl-8 col-xl-offset-2 col-lg-10 col-lg-offset-1">
            <div class="content">
                <a href="index.html" class="backlink">
                  <span title="Naar Home">Naar Home</span>
                </a>
            </div>
        </div>
    </section>
    <section class="row spacing-top-m">
      <div class="col-xs-12 col-lg-10 col-lg-offset-1">
        <div class="content content--background content--large-padding">
          <div class="spacing-inner-m">
            <h1>Pagina niet gevonden</h1>
            <p>Sorry, deze pagina bestaat niet (meer). U kunt verder zoeken vanaf de homepage.</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import {mapGetters} from "vuex";

export default {
  name: "app",
    computed: {
    ...mapGetters([
      "labels",
    ]),
  },
};
</script>
